import { ICellRendererParams } from "@ag-grid-community/core";
import { Center } from "@chakra-ui/react";
import { CheckIcon } from "shared/icons/CheckIcon";

export const MaybernTableCheckIconCellRenderer: React.FC<
  ICellRendererParams
> = ({ value }) =>
  value ? (
    <Center w="100%">
      <CheckIcon color="primary.500" />
    </Center>
  ) : null;
